import moment from 'moment'

import { defaultAnomalyDateRange } from '../core/variables'
import {
  ValidationChecks,
  CampaignCodesCompressed,
} from '../api-client/api-types'
import { Requests } from './support-reducer'

export const authenticateUser = (): ReduxAction => ({
  type: 'AUTHENTICATE',
})

export const updateOnboardingFirstName = (payload: object): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_FIRST_NAME',
  payload,
})

export const updateOnboardingLastName = (payload: object): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_LAST_NAME',
  payload,
})

export const setCurrentDropDown = (payload: object): ReduxAction => ({
  type: 'SET_CURRENT_DROPDOWN',
  payload,
})

export const setCurrentTooltip = (payload: object): ReduxAction => ({
  type: 'SET_CURRENT_TOOLTIP',
  payload,
})

export const updateQrSettingsGQL = (payload: object): ReduxAction => ({
  type: 'UPDATE_QR_SETTINGS_GQL',
  payload,
})

export const updateMarketingPermissionGQL = (payload: object): ReduxAction => ({
  type: 'UPDATE_MARKETING_PERMISSION_GQL',
  payload,
})

export const getStoredCodeStatsAsync = (): ReduxAction => ({
  type: 'GET_STORED_CAMPAIGN_STATS_ASYNC',
})

export const getUserAccountDetailsGQL = (): ReduxAction => ({
  type: 'GET_USER_ACCOUNT_DETAILS_GQL',
})

export const getSettingsGQL = (): ReduxAction => ({
  type: 'GET_SETTINGS_GQL',
})

export const getDataSourceMetricListGQL = (): ReduxAction => ({
  type: 'GET_DATA_SOURCE_METRIC_LIST_GQL',
})

export const getStoredCodeStatsGQL = (): ReduxAction => ({
  type: 'GET_STORED_CODE_STATS_GQL',
})

export const getCodesByUserGQL = (): ReduxAction => ({
  type: 'GET_CODES_BY_USER_GQL',
})

export const addCodesGQL = (payload: object): ReduxAction => ({
  type: 'ADD_CODES_GQL',
  payload,
})

export const removeShortLinkCandidatesGQL = (payload: object): ReduxAction => ({
  type: 'REMOVE_SHORT_LINK_CANDIDATES_GQL',
  payload,
})

export const getShortLinkCandidatesGQL = (payload: object): ReduxAction => ({
  type: 'GET_SHORT_LINK_CANDIDATES_GQL',
  payload,
})

export const validateShortLinkCandidateGQL = (
  payload: object,
): ReduxAction => ({
  type: 'VALIDATE_SHORT_LINK_CANDIDATES_GQL',
  payload,
})

export const addUserToAccountGQL = (payload: object): ReduxAction => ({
  type: 'ADD_USER_TO_ACCOUNT_GQL',
  payload,
})

export const setDashboardSettingsGQL = (payload: object): ReduxAction => ({
  type: 'SET_DASHBOARD_SETTINGS_GQL',
  payload,
})

export const getCampaignLinkDashboardMetricDataGQL = (
  payload: object,
): ReduxAction => ({
  type: 'GET_METRIC_DATA_GQL',
  payload,
})

export const getCampaignLinkDashboardMetricClickDataGQL = (
  payload: object,
): ReduxAction => ({
  type: 'GET_METRIC_CLICK_DATA_GQL',
  payload,
})

export const getCampaignLinkDashboardGraphGQL = (
  payload: object,
): ReduxAction => ({
  type: 'GET_DASHBOARD_GRAPH_GQL',
  payload,
})

export const getCampaignLinkDashboardGraphClickDataGQL = (
  payload: object,
): ReduxAction => ({
  type: 'GET_DASHBOARD_GRAPH_CLICK_DATA_GQL',
  payload,
})

export const getCampaignLinkDashboardTableGQL = (
  payload: object,
): ReduxAction => ({
  type: 'GET_DASHBOARD_TABLE_GQL',
  payload,
})

export const getCampaignLinkDashboardMetaGQL = (): ReduxAction => ({
  type: 'GET_DASHBOARD_META_GQL',
})

export const getCampaignLinkDashboardMetaDefaultsGQL = (): ReduxAction => ({
  type: 'GET_DASHBOARD_META_DEFAULTS_GQL',
})

export const getUserListGQL = (): ReduxAction => ({
  type: 'GET_USER_LIST_GQL',
})

export const getValidateResultsAsync = (payload: object): ReduxAction => ({
  type: 'GET_VALIDATE_RESULTS_ASYNC',
  payload,
})

export const validateUrlListAsync = (payload: object): ReduxAction => ({
  type: 'VALIDATE_URL_LIST_ASYNC',
  payload,
})

export const getEnterpriseBillingState = (): ReduxAction => ({
  type: 'GET_ENTERPRISE_BILLING_STATE_ASYNC',
})

export const updateEnterpriseBillingState = (payload: object): ReduxAction => ({
  type: 'UPDATE_ENTERPRISE_BILLING_STATE_ASYNC',
  payload,
})

export const addEnterpriseAccount = (payload: object): ReduxAction => ({
  type: 'ADD_ENTERPRISE_ACCOUNT_ASYNC',
  payload,
})

export const updateOnboardingEmail = (payload: object): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_EMAIL',
  payload,
})

export const getRemoteDashboardList = (): ReduxAction => ({
  type: 'GET_REMOTE_DASHBOARD_LIST_ASYNC',
})

export const getAAFTPDetailsAsync = (): ReduxAction => ({
  type: 'GET_AA_FTP_DETAILS_ASYNC',
})

export const updateOnboardingCompany = (payload: object): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_COMPANY',
  payload,
})

export const updateOnboardingPassword = (payload: object): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_PASSWORD',
  payload,
})

export const updateOnboardingPasswordConfirmation = (
  payload: object,
): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_PASSWORD_CONFIRMATION',
  payload,
})

export const updateOnboardingProgress = (payload: object): ReduxAction => ({
  type: 'UPDATE_ONBOARDING_PROGRESS',
  payload,
})

export const toggleOnboardingAgreement = (): ReduxAction => ({
  type: 'TOGGLE_ONBOARDING_AGREEMENT',
})

export const toggleOnboardingRedirect = (): ReduxAction => ({
  type: 'TOGGLE_ONBOARDING_REDIRECT',
})

export const updateLoginEmail = (payload: string): ReduxAction => ({
  type: 'UPDATE_LOGIN_EMAIL',
  payload,
})

export const updateLoginPassword = (payload: string): ReduxAction => ({
  type: 'UPDATE_LOGIN_PASSWORD',
  payload,
})

export const createNewBillingUserAsync = (payload: object): ReduxAction => ({
  type: 'CREATE_NEW_BILLING_USER_ASYNC',
  payload,
})

export const createNewClientAsync = (payload: object): ReduxAction => ({
  type: 'CREATE_NEW_CLIENT_ASYNC',
  payload,
})

export const authenticateAsync = (payload: object): ReduxAction => ({
  type: 'AUTHENTICATE_ASYNC',
  payload,
})

export const getPolicyAsync = (payload: object): ReduxAction => ({
  type: 'GET_POLICY_ASYNC',
  payload,
})

export const checkAuthenticationAsync = (): ReduxAction => ({
  type: 'CHECK_AUTHENTICATION_ASYNC',
})

export const getGooglePermissionAsync = (payload: object): ReduxAction => ({
  type: 'GET_GOOGLE_PERMISSION_ASYNC',
  payload,
})

export const loginGoogleSSOAsync = (payload: object): ReduxAction => ({
  type: 'LOGIN_GOOGLE_SSO_ASYNC',
  payload,
})

export const loginMicrosoftSSOAsync = (payload: object): ReduxAction => ({
  type: 'LOGIN_MICROSOFT_SSO_ASYNC',
  payload,
})

export const handleGoogleResponseAsync = (payload: string): ReduxAction => ({
  type: 'HANDLE_GOOGLE_RESPONSE_ASYNC',
  payload,
})

export const handleAdobeResponseAsync = (payload: string): ReduxAction => ({
  type: 'HANDLE_ADOBE_RESPONSE_ASYNC',
  payload,
})

export const resetPassword = (payload: object): ReduxAction => ({
  type: 'RESET_PASSWORD_ASYNC',
  payload,
})

export const requestPasswordResetAsync = (payload: string): ReduxAction => ({
  type: 'REQUEST_PASSWORD_RESET_ASYNC',
  payload,
})

export const requestAnomalyGraphData = (payload: {
  to?: string
  from?: string
  selector?: string
  metricID?: string
}): ReduxAction => {
  if (!payload.to || !payload.from) {
    const now = new Date(Date.now())
    const to = moment(now).subtract(1, 'days').format('YYYYMMDD')
    const from = moment(now)
      .subtract(defaultAnomalyDateRange, 'days')
      .format('YYYYMMDD')

    return {
      type: 'GET_ANOMALY_RANGE_ASYNC',
      payload: {
        ...payload,
        to,
        from,
      },
    }
  }

  return {
    type: 'GET_ANOMALY_RANGE_ASYNC',
    payload,
  }
}

export const requestAuditData = (): ReduxAction => ({
  type: 'GET_AUDIT_DATA_ASYNC',
})

// export const getAnomalyBreakdownById = (payload: any): ReduxAction => ({
//   type: 'GET_ANOMALY_BREAKDOWN_ASYNC',
//   payload,
// })

export const getAnomalyCausesAndSolutions = (payload: object): ReduxAction => ({
  type: 'GET_ANOMALY_BREAKDOWN_CAUSES_ASYNC',
  payload,
})

export const pageAccessAttempt = (payload: string): ReduxAction => ({
  type: 'PAGE_ACCESS_ATTEMPT',
  payload,
})

export const onLoginAttemptFail = (payload: string): ReduxAction => ({
  type: 'ON_LOGIN_ATTEMPT_FAIL',
  payload,
})

export const getAllSitesAsync = (): ReduxAction => ({
  type: 'GET_ALL_SITES_ASYNC',
})

export const getAllPropertiesAsync = (): ReduxAction => ({
  type: 'GET_ALL_PROPERTIES_ASYNC',
})

export const getAllViewsAsync = (): ReduxAction => ({
  type: 'GET_ALL_VIEWS_ASYNC',
})

export const getAllUsersAsync = (): ReduxAction => ({
  type: 'GET_ALL_USERS_ASYNC',
})

export const subscribeToAudit = (
  uid: string,
  runningDebug: boolean,
): ReduxAction => ({
  type: 'SUBSCRIBE_TO_AUDIT',
  payload: {
    uid,
    runningDebug,
  },
})

export const requestAnExpertAsync = (payload: object): ReduxAction => ({
  type: 'REQUEST_AN_EXPERT_ASYNC',
  payload,
})

export const resetRequestAnExpert = (): ReduxAction => ({
  type: 'RESET_REQUEST_AN_EXPERT',
})

export const getSelectedAccountAsync = (): ReduxAction => ({
  type: 'GET_SELECTED_ACCOUNT_ASYNC',
})

export const getUserDetailsAsync = (): ReduxAction => ({
  type: 'GET_USER_DETAILS_ASYNC',
})

export const getUserListAsync = (): ReduxAction => ({
  type: 'GET_USER_LIST_ASYNC',
})

export const addAccountAsync = (payload: object): ReduxAction => ({
  type: 'ADD_ACCOUNT_ASYNC',
  payload,
})

export const addNewUsersToAccountAsync = (payload: object): ReduxAction => ({
  type: 'ADD_USER_ASYNC',
  payload,
})

export const removeUserAsync = (payload: object): ReduxAction => ({
  type: 'REMOVE_USER_ASYNC',
  payload,
})

export const revokeEmailInviteAsync = (payload: {
  email: string
}): ReduxAction => ({
  type: 'REVOKE_EMAIL_INVITE_ASYNC',
  payload,
})

export const updateUserPermissionsAsync = (payload: {
  accountID: string
  permissionLevel: string
  userID: string
}): ReduxAction => ({
  type: 'UPDATE_USER_PERMISSIONS_ASYNC',
  payload,
})

export const changeUserPermissionsAsync = (payload: object): ReduxAction => ({
  type: 'CHANGE_USER_PERMISSIONS_ASYNC',
  payload,
})

export const closeAccountsAsync = (): ReduxAction => ({
  type: 'CLOSE_ACCOUNTS_ASYNC',
})

export const switchAccountAsync = (payload: string): ReduxAction => ({
  type: 'SWITCH_ACCOUNT_ASYNC',
  payload,
})

export const logActionAsync = (payload: {
  action: string
  longDescription: string | number
  websiteSection: string
}): ReduxAction => ({
  type: 'LOG_ACTIONS_ASYNC',
  payload,
})

export const logout = (): ReduxAction => ({
  type: 'DELETE_TOKEN',
})

export const loadCredentialsAsync = (): ReduxAction => ({
  type: 'LOAD_CREDENTIALS_ASYNC',
})

export const onRegisterAttemptFail = (payload: string): ReduxAction => ({
  type: 'ON_REGISTER_ATTEMPT_FAIL',
  payload,
})

//! router.tsx accepts any type for fName, lName, token, nonce and acceptedMarketing
//! May need fixing as this is unexpected
// interface registerAsyncPayload {
//   fName: string
//   lName: string
//   password: string
//   email: string | undefined
//   token: string
//   nonce?: any
//   id_token?: string | null
//   signUpMethod?: string
//   acceptedMarketing: boolean
// }

export const registerAsync = (payload: object): ReduxAction => ({
  type: 'REGISTER_ASYNC',
  payload,
})

export const resetForgotPassword = (): ReduxAction => ({
  type: 'REQUEST_PASSWORD_RESET_STATE',
})

export const getCalendarAnomalyRangeAsync = (payload: {
  fromDate: string
  toDate: string
}): ReduxAction => ({
  type: 'GET_CALENDAR_ANOMALY_RANGE_ASYNC',
  payload,
})

export const getCalendarEventsAsync = (payload: {
  fromDate: string
  toDate: string
}): ReduxAction => ({
  type: 'GET_CALENDAR_EVENTS_ASYNC',
  payload,
})

export const getCalendarCampaignsAsync = (payload: {
  fromDate: string
  toDate: string
}): ReduxAction => ({
  type: 'GET_CALENDAR_CAMPAIGNS_ASYNC',
  payload,
})

export const getGaCampaignsAsync = (payload: {
  fromDate: string
  toDate: string
}): ReduxAction => ({
  type: 'GET_CALENDAR_GA_CAMPAIGNS_ASYNC',
  payload,
})

export const getCampaignCodesByAccountAsync = (): ReduxAction => ({
  type: 'GET_CAMPAIGN_CODES_BY_ACCOUNT_ASYNC',
})

export const getCalendarKpiMetrics = (): ReduxAction => ({
  type: 'GET_CALENDAR_KPI_METRICS_ASYNC',
})

export const resetLoginAttemptFailAsync = (): ReduxAction => ({
  type: 'RESET_LOGIN_ATTEMPT_FAIL_ASYNC',
})

export const resetOnboardingCreateUserFailedAsync = (): ReduxAction => ({
  type: 'RESET_ONBOARDING_CREATE_USER_FAILED_ASYNC',
})

export const getCalendarKpis = (payload: {
  fromDate: string
  toDate: string
  metric: string
}): ReduxAction => ({
  type: 'GET_CALENDAR_KPIS_ASYNC',
  payload,
})

export const getCalendarGoalMetrics = (): ReduxAction => ({
  type: 'GET_CALENDAR_GOAL_METRICS_ASYNC',
})

export const getCampaignCodesAsync = (
  payload: {
    startDate?: string
    endDate?: string
  } | void,
): ReduxAction => ({
  type: 'GET_CAMPAIGN_CODES_ASYNC',
  payload,
})

// export const getBatchCampaignCodesAsync = (
//   payload: {
//     startDate?: string
//     endDate?: string
//   } | void,
// ): ReduxAction => ({
//   type: 'GET_BATCH_CAMPAIGN_CODES_ASYNC',
//   payload,
// })

export const getBatchQueryAsync = (payload: { batch: any }): ReduxAction => ({
  type: 'GET_BATCH_QUERY_ASYNC',
  payload,
})

export const updateGeneratorMasterSettingsAsync = (payload: {
  masterPrefix: string
  paramSeparator: string
  validationChecks: ValidationChecks[]
}): ReduxAction => ({
  type: 'UPDATE_GENERATOR_MASTER_SETTINGS_ASYNC',
  payload,
})

export const updateAccountDescriptionAsync = (payload: {
  accountID: string
  accountName?: string
  websiteURL?: string
}): ReduxAction => ({
  type: 'UPDATE_ACCOUNT_DESCRIPTION_ASYNC',
  payload,
})

export const getUsersCampaignCodesAsync = (payload: {
  startDate?: string
}): ReduxAction => ({
  type: 'GET_USERS_CAMPAIGN_CODES_ASYNC',
  payload,
})

export const getBatchUsersCampaignCodesAsync = (): ReduxAction => ({
  type: 'GET_BATCH_USERS_CAMPAIGN_CODES_ASYNC',
})

export const getCampaignCodeGeneratorAsync = (): ReduxAction => ({
  type: 'GET_CAMPAIGN_CODE_GENERATOR_ASYNC',
})

export const updateCampaignCodeGeneratorAsync = (
  payload: object,
): ReduxAction => ({
  type: 'UPDATE_CAMPAIGN_CODE_GENERATOR_ASYNC',
  payload,
})

export const deleteGeneratorParameterAsync = (payload: {
  removeID: string
}): ReduxAction => ({
  type: 'DELETE_GENERATOR_PARAMETER_ASYNC',
  payload,
})

export const addGeneratorParameterAsync = (payload: object): ReduxAction => ({
  type: 'ADD_GENERATOR_PARAMETER_ASYNC',
  payload,
})

export const updateCampaignCodeGeneratorOrderAsync = (payload: {
  newOrder: any[]
}): ReduxAction => ({
  type: 'UPDATE_CAMPAIGN_CODE_GENERATOR_ORDER_ASYNC',
  payload,
})

export const updateGeneratorParameterAsync = (payload: {
  fieldID?: string
  fieldName?: string
  prefix?: string
  helpText?: string
  required?: boolean
  forceLowerCase?: boolean
  metaParameter?: boolean
  copyFromField?: any[]
}): ReduxAction => ({
  type: 'UPDATE_GENERATOR_PARAMETER_ASYNC',
  payload,
})

export const updateGeneratorParameterSelectUpdateAsync = (payload: {
  fieldID?: string
  updatedOption: any
}): ReduxAction => ({
  type: 'UPDATE_GENERATOR_PARAMETER_SELECT_UPDATE_ASYNC',
  payload,
})

export const updateGeneratorParameterSelectDeleteAsync = (payload: {
  fieldID?: string
  optionID?: string
}): ReduxAction => ({
  type: 'UPDATE_GENERATOR_PARAMETER_SELECT_DELETE_ASYNC',
  payload,
})

export const updateGeneratorParameterSelectAddOptionAsync = (payload: {
  fieldID: string
  action?: string
  newOption: {
    hide: boolean
    optionName: string
    optionValue: string
  }
}): ReduxAction => ({
  type: 'UPDATE_GENERATOR_PARAMETER_SELECT_ADD_OPTION_ASYNC',
  payload,
})

export const saveToCopy = (payload: any[]): ReduxAction => ({
  type: 'SAVE_TO_COPY',
  payload,
})

export const updateCampaignCodeAsync = (payload: {
  compressed: CampaignCodesCompressed
  full: object
}): ReduxAction => ({
  type: 'UPDATE_CAMPAIGN_CODE_ASYNC',
  payload,
})

export const deleteCampaignCodesAsync = (payload: any[]): ReduxAction => ({
  type: 'DELETE_CAMPAIGN_CODES_ASYNC',
  payload,
})

export const onBoardingAttempt = (payload: string): ReduxAction => ({
  type: 'ONBOARDING_CREATE_USER_FAILED',
  payload,
})

export const getExplainSetup = (): ReduxAction => ({
  type: 'GET_EXPLAIN_SETUP_ASYNC',
})

export const getUpdateRequestsAsync = (): ReduxAction => ({
  type: 'GET_UPDATE_REQUEST_ASYNC',
})

export const setUpdateRequestsAsync = (payload: {
  changeRequests: Requests[]
  dismissed: boolean
  forceCompleted: boolean
  requestID: string
}): ReduxAction => ({
  type: 'SET_UPDATE_REQUEST_ASYNC',
  payload,
})

export const sendUpdateRequestsAsync = (
  payload: {
    approved: boolean
    changeRequests: Requests[]
    message: string
    requestID: string
  } | null,
): ReduxAction => ({
  type: 'SEND_UPDATE_REQUEST_ASYNC',
  payload,
})

export const getGaMetrics = (): ReduxAction => ({
  type: 'GET_GA_METRICS_ASYNC',
})

export const getCurrentKeyMetrics = (): ReduxAction => ({
  type: 'GET_CURRENT_KEY_METRICS_ASYNC',
})

export const getAnomalyDateDescription = (payload: {
  metric: string
  date: string
}): ReduxAction => ({
  type: 'GET_ANOMALY_DESCRIPTION_ASYNC',
  payload,
})

export const getAllGaDimensions = (): ReduxAction => ({
  type: 'GET_ALL_GA_DIMENSIONS_ASYNC',
})

export const addMetric = (payload: {
  apiName: string
  displayName: string
  detectionMethod: string
  increaseSentimentPositive: boolean
  sendAlert: boolean
  dataSource: string
  metricItemToBeAdded: any
}): ReduxAction => ({
  type: 'ADD_METRIC_ASYNC',
  payload,
})

export const updateMetric = (payload: object): ReduxAction => ({
  type: 'UPDATE_METRIC_ASYNC',
  payload,
})

export const removeMetric = (payload: { metricID: string }): ReduxAction => ({
  type: 'REMOVE_METRIC_ASYNC',
  payload,
})

export const saveExplainSetup = (payload: object): ReduxAction => ({
  type: 'SAVE_EXPLAIN_SETUP_ASYNC',
  payload,
})

export const updateAnomalyDescription = (payload: object): ReduxAction => ({
  type: 'UPDATE_ANOMALY_DESCRIPTION_ASYNC',
  payload,
})

export const updateAnomalyDescriptionReducersOnly = (
  payload: object,
): ReduxAction => ({
  type: 'UPDATE_ANOMALY_REDUCERS_ONLY',
  payload,
})

export const saveLinkPerformanceReportGQL = (payload: any): ReduxAction => ({
  type: 'SAVE_LINK_REPORT_GQL',
  payload,
})

export const updateLinkPerformanceUserPrefsGQL = (
  payload: any,
): ReduxAction => ({
  type: 'UPDATE_LINK_REPORT_LIST_GQL',
  payload,
})

export const removeSavedLinkPerformanceReportGQL = (
  payload: any,
): ReduxAction => ({
  type: 'REMOVE_LINK_REPORT_GQL',
  payload,
})

export const updateSavedLinkPerformanceReportGQL = (
  payload: any,
): ReduxAction => ({
  type: 'UPDATE_LINK_REPORT_GQL',
  payload,
})

export const getOnboardingStatus = (): ReduxAction => ({
  type: 'GET_ONBOARDING_STATUS',
})

export const listSavedLinkPerformanceReportsAsync = (): ReduxAction => ({
  type: 'LIST_SAVED_REPORTS_GQL',
})

export const updatePreferredHomepage = (payload: string): ReduxAction => ({
  type: 'UPDATE_PREFERRED_HOMEPAGE_GQL',
  payload,
})

export default {}
